import { withNavBar } from '../../shared/NavBar/NavBar';

const PrivacyPolicy = () => {
  return (
    <div>
      <h4>Privacy Policy</h4>
      <p>
        In this Privacy Policy, 'us' 'we' or 'our' means the Bayer AG. We are
        committed to respecting your privacy. Our Privacy Policy sets outs out
        how we collect, use, store and disclose your personal information. By
        providing personal information to us, you consent to our collection, use
        and disclosure of your personal information in accordance with this
        Privacy Policy and any other arrangements that apply between us. We may
        change our Privacy Policy from time to time by publishing changes to it
        on our website. We encourage you to check our website periodically to
        ensure that you are aware of our current Privacy Policy.
      </p>
      <h5>Information we collect:</h5>
      <p>When you use our App, we may collect the following information:</p>
      <ul>
        <li>
          <p>
            Personal information: We may collect personal information such as
            your name and email address when you register or update for your
            account.
          </p>
        </li>

        <li>
          <p>
            Information about your photos: We collect information about your
            photos such as file names, file types, and metadata, that you upload
            to our website.
          </p>
        </li>

        <li>
          <p>
            Usage information: We may collect information about how you use this
            product, such as the features you use and the actions you take.
          </p>
        </li>
      </ul>
      <h5>How we use your information:</h5>
      <p>We may use your information for the following purposes:</p>
      <ul>
        <li>
          <p>
            To provide and improve our services: We use your information to
            operate and improve the App and to personalize your experience.
          </p>
        </li>

        <li>
          <p>
            To communicate with you: We may use your contact information to send
            you updates about our services or to respond to your inquiries.
          </p>
        </li>

        <li>
          <p>
            To comply with legal obligations: We may use your information to
            comply with applicable laws and regulations.
          </p>
        </li>
      </ul>
      <h5>How we share your information:</h5>
      <p>
        We may share your information with third parties in the following
        circumstances:
      </p>
      <ul>
        <li>
          <p>
            Service providers: We may share your information with third-party
            service providers who help us operate and improve the App.
          </p>
        </li>

        <li>
          <p>
            Business transfers: If we sell or transfer our business or assets,
            we may share your information with the buyer or transferee.
          </p>
        </li>

        <li>
          <p>
            Legal requirements: We may disclose your information in response to
            a subpoena, court order, or other legal process.
          </p>
        </li>
      </ul>
      <br />
      <p>
        For more information please visit:&nbsp;
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.bayer.com/en/privacy-statement"
        >
          Bayer AG Privacy Statement
        </a>
      </p>
      <p>
        If you have any questions or concerns about our privacy policy, please
        contact us at:&nbsp;
        <a href="mailto:itrack.habitat@bayer.com">itrack.habitat@bayer.com</a>
      </p>
    </div>
  );
};

export default withNavBar(PrivacyPolicy);
